'use client';

import Link from 'next/link';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

import { loadThemeComponent } from '@/core/config/theme-component-loader';

const CustomButton = loadThemeComponent('CustomButton');

export default function SupportInformation({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map(item => (
        <AccordionItem value={item.title} key={item.title}>
          <AccordionTrigger className="hover:no-underline cursor-pointer text-xs font-primary-bold">
            {item.title}
          </AccordionTrigger>
          <AccordionContent className="text-primary-600 text-xs leading-6.5">
            <p className="mb-4">{item.description}</p>
            {item.link && item.buttonContent && (
              <CustomButton variant="secondary">
                <Link href={item.link}>{item.buttonContent}</Link>
              </CustomButton>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
